import { TEMPLATE_ACCENT_DEFAULTS } from '@cibli/shared';
import { z } from 'zod';

export const classicParamsSchema = z.object({
  accentColor: z.string().default(TEMPLATE_ACCENT_DEFAULTS.classic),
  spacing: z.enum(['compact', 'normal', 'aere']).default('normal'),
});

export type ClassicParams = z.infer<typeof classicParamsSchema>;

export const classicDefaultParams: ClassicParams = classicParamsSchema.parse({});
